import "./home.css";
import neha_img from "../image/neha-img.jpg";
import dar1 from "../image/dar1.jpg";
import dello from "../image/dello.jpg";
import Typewriter from "typewriter-effect";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { useState } from "react";
import GitHubIcon from "@material-ui/icons/GitHub";
import { useEffect } from "react";

export const HomePage = () => {
  const [imgNo, setImgNo] = useState(0);
  const [img, setImg] = useState(neha_img);

  const goGithub = () => {
    window.open("https://github.com/Neha-251", "_blank");
  };

  const goLinkedin = () => {
    window.open("https://www.linkedin.com/in/2510-neha-sen/", "_blank");
  };

  const goResume = () => {
    window.open(
      `https://drive.google.com/file/d/1dyUxJAGs2tbl8CgiDMgSQcO9NcaFiuPg/view?usp=sharing`,
      `_blank`
    );
  };

  return (
    <div className="aboutContainer" id="home">
      <div className="corner">
        <GitHubIcon onClick={goGithub} className="git_icon" />
      </div>

      {/* <div className="first-block">
        <svg id="faceSvg" viewBox="0 0 1000 1000" height="300px" width="300px">
          <defs>
            <pattern
              id="img1"
              patternUnits="userSpaceOnUse"
              width="1100"
              height="1100"
            >
              <image
                href={img}
                className="neha-img"
                x="80"
                y="80"
                width="1000"
                height="1000"
              />
            </pattern>
          </defs>
          <path
            transform="translate(-80, -100) scale(0.97)"
            stroke="#e679c3"
            stroke-width="0.5"
            // fill="grey"
            fill="url(#img1)"
            d="M 320.8512217903687 200.54035691370126 C 569 76.46596780888561 749.9629921252078 119.64696723907218 949.9629921252078 319.6469672390722 C 1125 494.68397511386434 1093.2043831794754 644.157554597611 993.2043831794754 844.157554597611 C 768 1294.5663209565619 402.56311035913245 1045.8038549210346 202.56311035913248 945.8038549210347 C 7 848.0222997414686 120.8512217903687 300.54035691370126 320.8512217903687 200.54035691370126 Z"
          ></path>
        </svg>
      </div> */}
      {/* <div className="rightSide">
        <div class="container_cube">
          <div class="cube">
            <div class="face front">
              <p id="cube_p">Worked on 4 Gorup Projects</p>
            </div>
            <div class="face right"></div>
            <div class="face left">
              <p id="cube_p">I've built Solo projects</p>
            </div>
            <div class="face back">
              <svg
                id="faceSvg"
                viewBox="0 0 1000 1000"
                height="300px"
                width="300px"
              >
                <defs>
                  <pattern
                    id="img1"
                    patternUnits="userSpaceOnUse"
                    width="1100"
                    height="1100"
                  >
                    <image
                      href={img}
                      className="neha-img"
                      x="80"
                      y="80"
                      width="1000"
                      height="1000"
                    />
                  </pattern>
                </defs>
                <path
                  transform="translate(-80, -100) scale(0.97)"
                  stroke="#e679c3"
                  stroke-width="0.5"
                  // fill="grey"
                  fill="url(#img1)"
                  d="M 320.8512217903687 200.54035691370126 C 569 76.46596780888561 749.9629921252078 119.64696723907218 949.9629921252078 319.6469672390722 C 1125 494.68397511386434 1093.2043831794754 644.157554597611 993.2043831794754 844.157554597611 C 768 1294.5663209565619 402.56311035913245 1045.8038549210346 202.56311035913248 945.8038549210347 C 7 848.0222997414686 120.8512217903687 300.54035691370126 320.8512217903687 200.54035691370126 Z"
                ></path>
              </svg>
            </div>
            <div class="face top"></div>
            <div class="face bottom">
              <p id="cube_p">Hi, I'm Neha. Nice to meet you</p>
            </div>
          </div>
        </div>
      </div> */}

      <div className="leftSide">
        <p className="hi_txt">Hello, I'm Neha Sen</p>
        <div className="dynamic_txt">
          <Typewriter
            options={{
              strings: [
                "Programmer",
                "Full Stack Web Developer",
                "Frontend Developer",
              ],
              autoStart: true,
              loop: true,
            }}
          />
        </div>

        <div className="description">
          <p data-aos="fade-up">
            Besides being a growth-oriented, creative Full Stack Web Developer,
            specialized at MERN Stack, I am a loved team collaborator. I have a
            strong vision of making myself much more skilled and efficient.
          </p>
        </div>

        <div className="iconsDiv">
          <FaGithub
            data-aos="fade-left"
            className="resume_over_icon"
            style={{ cursor: "pointer" }}
            onClick={goGithub}
          />
          <FaLinkedin
            data-aos="fade-right"
            className="resume_over_icon"
            style={{ cursor: "pointer" }}
            onClick={goLinkedin}
          />
        </div>

        {/* <button
          data-aos="fade-up-right"
          style={{ cursor: "pointer" }}
          onClick={goResume}
          className="resumeBtn"
        >
          Resume
        </button> */}
      </div>
    </div>
  );
};
